const HEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

/** "#0f766e" or "#fff" -> [15, 118, 110]; null if not a valid hex color. */
export function hexToRgb(hex) {
  if (typeof hex !== 'string' || !HEX.test(hex.trim())) return null;
  let h = hex.trim().slice(1);
  if (h.length === 3)
    h = h
      .split('')
      .map((c) => c + c)
      .join('');
  return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
}

export function isHexColor(value) {
  return hexToRgb(value) !== null;
}

export function luminance([r, g, b]) {
  const [R, G, B] = [r, g, b].map((v) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * R + 0.7152 * G + 0.0722 * B;
}

export function contrastRatio(a, b) {
  const [hi, lo] = [luminance(a), luminance(b)].sort((x, y) => y - x);
  return (hi + 0.05) / (lo + 0.05);
}

/** White or near-black, whichever reads better on the given color. */
export function readableOn(rgb) {
  const dark = [17, 17, 17];
  return contrastRatio(rgb, dark) > contrastRatio(rgb, [255, 255, 255]) ? dark : [255, 255, 255];
}
